import React from 'react'
import { connect } from 'react-redux'
import NavigationBar from './NavigationBar'
import FlashMessagesList from './flash/FlashMessagesList'
import { isEmpty } from 'lodash'

class App extends React.Component {
  render() {
    const {
      auth: {
        rights,
        isAuthenticated
      },
      settings
    } = this.props;
    var current = this.props.location.pathname;
    if(current.split('/').length>1){
      current = current.split('/')[1];
    }
    if (isAuthenticated && (isEmpty(rights) || isEmpty(settings))) {
      return (
        <div>Loading...</div>
      );
    }
    return (
      <div className="container full-height">
        <NavigationBar current={current} />
        <FlashMessagesList />
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(store) {
  return {
    auth: store.auth,
    settings: store.settings
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js